module.exports = __webpack_public_path__ + "static/img/0.2da20cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/0.png
// module id = ep83
// module chunks = 2